module.exports = __webpack_public_path__ + "img/training-v2.ad69572c.jpg";